import { intl } from "LocaleWrapper";
import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { PjkTariff } from "__generated__/graphql";

const PjkTariffSelect = ({ value, onChange }: Omit<SelectProps<PjkTariff, false>, "fetchOptions">) => {
	return (
		<Select
			value={value}
			onChange={onChange}
			fetchOptions={Object.values(PjkTariff)}
			getOptionLabel={option => intl.formatMessage({ id: `PJK_TARIFF_${option}` })}
		/>
	);
};

export default PjkTariffSelect;
